import type { Environments } from "@/types";

export default (): Environments => {
  const { hostname } = window.location;

  if (hostname === "localhost" || hostname.endsWith(".test")) {
    return "development";
  }

  if (hostname.includes("staging.")) {
    return "staging";
  }

  return "production";
};
